// import {getCookie} from "../../common/js/util";

const user = {
    state: {
        includePageNames: [],
        firstLevelData: [],
        parentCode: "",
        hotelCode: "", // 酒店code 
        hotelItems: 1, //  酒店的主题风格
        hotelSet: "",
        moduleParams: "",
        userLogin: "",
        foodData: "",
        themeType: 2,
        selectPosition: -1,
        styleType: 4,
        versionType: 2, // 版本类型
        appCommonSet: {},
        innerPage: [],
        welcomeData: {}
    },

    mutations: {
        firstLevelData(state, msg) {
            state.firstLevelData = msg;
        },
        includePageNames(state, msg) {
            state.includePageNames = msg;
        },
        parentCode(state, msg) {
            state.parentCode = msg;
        },
        hotelCode(state, msg) {
            state.hotelCode = msg;
        },
        hotelItems(state, msg) {
            state.hotelItems = msg;
        },
        hotelSet(state, msg) {
            state.hotelSet = msg;
        },
        moduleParams(state, msg) {
            state.moduleParams = msg;
        },
        userLogin(state, msg) {
            state.userLogin = msg;
        },
        foodData(state, msg) {
            state.foodData = msg;
        },
        themeType(state, msg) {
            state.themeType = msg;
        },
        selectPosition(state, msg) {
            state.selectPosition = msg;
        },
        styleType(state, msg) {
            state.styleType = msg;
        },
        versionType(state, msg) {
            state.versionType = msg;
        },
        appCommonSet(state, msg) {
            state.appCommonSet = msg;
        },
        innerPage(state, msg) {
            state.innerPage = msg;
        },
        welcomeData(state, msg) {
            state.welcomeData = msg;
        }
    },
}

export default user


// WEBPACK FOOTER //
// ./src/store/modules/user.js